import { Button, Col, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import LoaDetailsInfoList from '../LoaDetailsInfoList';
import { toLocaleFormatSlash } from '../../../../helpers/dateFormat';

interface LeaveOfAbsenceRecordsModalProps {
  isOpen: boolean;
  toggle: () => void;
  workerName?: string;
  loaRecords: any[];
  mode?: 'view' | 'confirmEnd';
  actualLastDay?: string;
  onConfirmEnd?: () => void | Promise<void>;
  confirmLoading?: boolean;
}

const LeaveOfAbsenceRecordsModal = ({
  isOpen,
  toggle,
  workerName,
  loaRecords,
  mode = 'view',
  actualLastDay,
  onConfirmEnd,
  confirmLoading = false,
}: LeaveOfAbsenceRecordsModalProps) => {
  const isConfirmEnd = mode === 'confirmEnd';

  const handleConfirm = async () => {
    if (onConfirmEnd) {
      await onConfirmEnd();
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      size="lg"
      scrollable
      centered
      style={{
        maxWidth: 'min(900px, calc(100vw - 2rem))',
        width: '100%',
        margin: '0.5rem auto',
        maxHeight: 'calc(100vh - 1rem)',
      }}
    >
      <ModalHeader toggle={toggle}>
        {isConfirmEnd ? 'Confirm End Leave of Absence' : 'Leave of Absence Records'}
      </ModalHeader>
      <ModalBody>
        {isConfirmEnd && (
          <Row className="mb-3">
            <Col>
              <h5 className="mb-0">LOA Overview</h5>
              <small className="text-muted">Review the details before ending the Leave of Absence</small>
            </Col>
          </Row>
        )}
        <LoaDetailsInfoList workerName={workerName} loaRecords={loaRecords} />
        {isConfirmEnd && actualLastDay && (
          <Row className="mt-3">
            <Col>
              <div className="alert alert-info mb-0">
                <strong>Actual Last day of LOA:</strong> {toLocaleFormatSlash(actualLastDay)}
              </div>
            </Col>
          </Row>
        )}
      </ModalBody>
      <ModalFooter
        className={`flex-shrink-0 flex-wrap ${isConfirmEnd ? 'justify-content-between' : 'justify-content-end'}`}
        style={{ gap: '0.5rem' }}
      >
        {isConfirmEnd ? (
          <>
            <Button color="secondary" onClick={toggle} disabled={confirmLoading} className="m-0">
              Cancel
            </Button>
            <Button color="primary" onClick={handleConfirm} disabled={confirmLoading} className="m-0">
              {confirmLoading ? 'Saving...' : 'Confirm End LOA'}
            </Button>
          </>
        ) : (
          <Button color="primary" onClick={toggle} className="m-0">
            Close
          </Button>
        )}
      </ModalFooter>
    </Modal>
  );
};

export default LeaveOfAbsenceRecordsModal;
